<template>
  <main>
    <form @submit="onSubmit">
      <b-card>
        <h3 style="font-weight: bold">Terms & Conditions</h3>
        <ckeditor v-model="content" :config="editorConfig"></ckeditor>
      </b-card>
      <b-button variant="primary" type="submit">{{
        loading ? "Saving" : "Save"
      }}</b-button>
    </form>
  </main>
</template>

<script>
/* eslint-disable */
import { BCard, BRow, BCol, BFormTextarea, BButton } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { editTerms, fetchTerms } from "@/service/api.service";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormTextarea,
  },

  data() {
    return {
      content: "",
      loading: false,
      data: null,
      editorData: "<p>Type terms and conditions here...</p>",
      editorConfig: {
        // The configuration of the editor.
      },
    };
  },
  created() {
    this.getTerms();
  },
  methods: {
    routeTo(path) {
      this.$router.push(path);
    },
    onSubmit(e) {
      e.preventDefault();
      this.updateTerms();
    },
    getTerms() {
      fetchTerms()
        .then((res) => res.json())
        .then((response) => {
          if (response.valid) {
            this.data = response.data;
            this.content = this.data.content;
          }
        })
        .catch((e) => {
          this.showToast("Error", "danger", e);
        });
    },
    updateTerms() {
      this.loading = true;
      editTerms({ id: this.data.id, content: this.content })
        .then((res) => res.json())
        .then((response) => {
          this.loading = false;
          if (response.valid) {
            this.showToast(
              "Success",
              "success",
              "Terms and Conditions updated successfully"
            );
          }
        })
        .catch((e) => {
          this.loading = false;
          this.showToast("Error", "danger", e);
        });
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          text: text,
          icon: title === "Error" ? "TrashIcon" : "DoneIcon",
          variant: variant,
        },
      });
    },
  },
};
</script>

<style scoped></style>
